import { JsonPipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

declare var require: any

@Pipe({ name: 'second_time', pure: false })
export class SecondToTime implements PipeTransform {
  transform(text: number): any {
    if (text) {
      let totalSeconds: any = text
      totalSeconds = totalSeconds * 60
      const hours: any = Math.floor(totalSeconds / 3600)
      const minutes: any = Math.floor((totalSeconds - hours * 3600) / 60)
      let seconds: any = totalSeconds - hours * 3600 - minutes * 60

      seconds = Math.round(seconds * 100) / 100

      let result: any = hours < 10 ? '0' + hours : hours
      let strings: any = ''
      if (hours > 0) {
        if (hours === 1) {
          result += ' hr'
        } else {
          result += ' hrs'
        }

        strings += result
      }
      if (minutes > 0) {
        if (minutes === 1) {
          strings += ' ' + (minutes < 10 ? '0' + minutes : minutes) + ' min'
        } else {
          strings += ' ' + (minutes < 10 ? '0' + minutes : minutes) + ' mins'
        }
      }
      return strings
    } else {
      return '0 Sec'
    }
  }

}

@Pipe({ name: 'timeFormat' })
export class timeFormat implements PipeTransform {
  constructor() { }
  transform(time: any) {
    let hour = (time.split(':'))[0]
    let min = (time.split(':'))[1]
    let part = hour > 12 ? 'PM' : 'AM';
    if (parseInt(hour) == 0)
      hour = 12;
    min = (min + '').length == 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour + '').length == 1 ? `0${hour}` : hour;
    return `${hour}:${min} ${part}`
  }


}
@Pipe({ name: 'convertWeek' })
export class weekFormate implements PipeTransform {
  transform(week: any) {
    let weekDays: any = [{ name: ' Sunday', sequence: 0, },
    { name: ' Monday', sequence: 1, },
    { name: ' Tuesday', sequence: 2, },
    { name: ' Wednesday', sequence: 3, },
    { name: ' Thursday', sequence: 4, },
    { name: ' Friday', sequence: 5, },
    { name: ' Saturday', sequence: 6, },]
    let object = []
    if (JSON.parse(week).length === weekDays.length) {
      return 'All Week'
    } else {
      JSON.parse(week).map((el) => {
        const find = weekDays.filter(x => x.sequence == el)[0]
        object.push(find.name + '')
      })
      return object
    }
  }
}
@Pipe({name: 'convertSecond'})
export class convertSecond implements PipeTransform{
  transform(time:any) {
    let hours = Math.floor(time /60 /60);
    let minutes = Math.floor(time /60) - (hours * 60)
    let seconds = time % 60
    if(time > 3599){
      const convertTime = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') +
     ':' + seconds.toString().padStart(2, '0') + ' hours';
    return convertTime
    }
    else if(time >= 60){
      const convertTime =  minutes.toString().padStart(2, '0') +
      ':' + seconds.toString().padStart(2, '0') + ' Minutes';
     return convertTime
    }
    else{
      const convertTime = seconds.toString().padStart(2, '0') + ' Seconds';
      return convertTime
    }
  

  }
}


